import {
  changeSurveyPreferencesConstants,
  DEFAULT_SURVEY_PREFERENCE_CHECKBOX_STATE,
} from "../../../constants";

const {
  NEGATIVE_RESPONSE_ID_KEY,
  POSITIVE_RESPONSE_ID_KEY,
  PASSIVE_RESPONSE_ID_KEY,
} = changeSurveyPreferencesConstants;

/**
 * Build checkbox state from saved survey preference API fields.
 */
export const createCheckboxStateFromPreferences = (surveyPreferences) => {
  const hasPositive = !!surveyPreferences?.[POSITIVE_RESPONSE_ID_KEY];
  const hasNegative = !!surveyPreferences?.[NEGATIVE_RESPONSE_ID_KEY];
  const hasPassive = !!surveyPreferences?.[PASSIVE_RESPONSE_ID_KEY];

  return {
    isPositiveResponse: hasPositive,
    isNegativeResponse: hasNegative,
    isPassiveResponse: hasPassive,
    isTurnOffResponse: !(hasPositive || hasNegative || hasPassive),
  };
};

/**
 * Reset preference checkboxes and toggle "turn off responses".
 */
export const createTurnedOffCheckboxState = (previousTurnOffValue) => ({
  ...DEFAULT_SURVEY_PREFERENCE_CHECKBOX_STATE,
  isTurnOffResponse: !previousTurnOffValue,
});

/**
 * Toggle one preference checkbox and clear "turn off responses".
 */
export const togglePreferenceCheckbox = (prevState, name) => ({
  ...prevState,
  [name]: !prevState[name],
  isTurnOffResponse: false,
});

/**
 * True when Update should be disabled (nothing selected).
 */
export const isSurveyPreferenceUpdateDisabled = (checkboxState) =>
  !checkboxState.isPositiveResponse &&
  !checkboxState.isPassiveResponse &&
  !checkboxState.isNegativeResponse &&
  !checkboxState.isTurnOffResponse;
